import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import {
	ThemeProvider,
} from "styled-components";
import "bootstrap/dist/css/bootstrap.min.css"
import DEFAULT_THEME from "./constants/theme";
import { ToastContainer } from "react-toastify";
import { I18nextProvider } from "react-i18next";
import { AppProvider } from "models/app-provider";
import i18n from "./i18n"

ReactDOM.render(
	<React.StrictMode>
		<ThemeProvider theme={DEFAULT_THEME}>
			<AppProvider>
				<I18nextProvider i18n={i18n}>
					<ToastContainer />
					<BrowserRouter>
						<App />
					</BrowserRouter>
				</I18nextProvider>
			</AppProvider>
		</ThemeProvider>

	</React.StrictMode>
	, document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
